import { useEffect } from 'react';
import { useWindowSize } from '../hooks/useWindowSize';

/**
 * Component that updates CSS custom properties based on zoom level
 * This ensures CSS remains responsive across different zoom levels
 */
const ZoomAwareCSS = () => {
    const { zoomLevel, scaleFactor, normalizedWidth, normalizedHeight } = useWindowSize();

    useEffect(() => {
        if (typeof document !== 'undefined') {
            const root = document.documentElement;
            
            // Update CSS custom properties
            root.style.setProperty('--zoom-scale', scaleFactor);
            root.style.setProperty('--viewport-width', `${normalizedWidth}px`);
            root.style.setProperty('--viewport-height', `${normalizedHeight}px`);
            root.style.setProperty('--content-max-width', `${normalizedWidth}px`);
            root.style.setProperty('--content-max-height', `${normalizedHeight}px`);
            
            // Debug logging
            console.log(`ZoomAwareCSS: Updated CSS properties - Scale: ${scaleFactor}, Width: ${normalizedWidth}, Height: ${normalizedHeight}`);
        }
    }, [zoomLevel, scaleFactor, normalizedWidth, normalizedHeight]);

    // This component doesn't render anything visible
    return null;
};

export default ZoomAwareCSS;